export var ActiveState;
(function (ActiveState) {
    ActiveState["DISMISSED"] = "Dismissed";
    ActiveState["ACTIVE"] = "Active";
})(ActiveState || (ActiveState = {}));
export class OptimizerSearchRequestModel {
    search;
    activeState;
    from;
    size;
    updatedBy;
    createdBy;
    sortBy;
    sortOrder;
}
export class OptimizerSearchResponseModel {
    results;
    pageSize;
    pageNumber;
    total;
}
//# sourceMappingURL=optimizer-search.js.map